export const getUserGuideFilesUrl = () => '/guide/guide-files/';
export default getUserGuideFilesUrl;
